import React from 'react';
import { Box, Card, CardContent, Typography, Chip, useTheme } from '@mui/material';

export interface KpiCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  color?: string;
  trend?: {
    label: string;
    positive?: boolean;
  };
}

const KpiCard: React.FC<KpiCardProps> = ({ title, value, subtitle, icon, color, trend }) => {
  const theme = useTheme();
  const defaultColor = theme.palette.mode === 'dark' ? '#65f0c5' : '#1a1a1a';
  const iconColor = color || defaultColor;
  return (
    <Card sx={{ height: '100%', transition: 'transform 0.2s, box-shadow 0.2s', '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 } }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>
          {icon && (
            <Box sx={{ color: iconColor, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: '50%', bgcolor: `${iconColor}14` }}>
              {icon}
            </Box>
          )}
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
        {trend && (
          <Box sx={{ mt: 1 }}>
            <Chip size="small" color={trend.positive ? 'success' : 'error'} label={trend.label} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default KpiCard;


